import { initMonitoring } from '@/lib/monitoring'
import { captureException } from '@sentry/react'

initMonitoring()
// Load the app only after monitoring is ready, including module evaluation failures.
void import('./bootstrap').catch((error: unknown) => {
  captureException(error, { tags: { operation: 'bootstrap' } })
  const root = document.getElementById('root')
  if (root) {
    root.setAttribute('role', 'alert')
    root.textContent = 'Something went wrong. Please reload the page.'
  }
})
